var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.6,0c0.4,0.4,0.8,0.8,1.1,1.2C12.3,6.8,6.8,12.4,1.4,18c-0.4-0.4-0.7-0.8-1.1-1.1c0.6-0.6,1.2-1.3,1.8-1.9 c-0.2-0.1-0.4-0.1-0.6-0.2C0.5,14.3,0,13.5,0,12.4c0-2.3,0-4.5,0-6.8c0-1.4,1.1-2.5,2.4-2.5c2.7,0,5.5,0,8.2,0 c0.8,0,1.4,0.3,1.9,0.9c0,0,0,0,0.1,0.1c0,0,0,0,0,0C13.9,2.7,15.3,1.4,16.6,0z M6.6,4.8c-1.3,0-2.7,0-4,0C2,4.8,1.6,5.1,1.6,5.7 c0,2.2,0,4.4,0,6.6c0,0.6,0.3,0.9,0.9,0.9c0.4,0,0.7,0,1.1,0c0.1,0,0.2,0,0.2-0.1c2.5-2.6,5-5.1,7.4-7.7c0.1-0.1,0.1-0.2,0-0.3 c-0.2-0.3-0.5-0.4-0.8-0.4C9.2,4.8,7.9,4.8,6.6,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.3,5.7c0.6,0,1.1,0,1.7,0c0,0.1,0,0.1,0,0.2c0,2.7,0,5.4,0,8.1c0,0.6-0.4,1-0.9,0.9c-0.2,0-0.3-0.1-0.5-0.2 c-1.1-0.8-2.2-1.6-3.4-2.3c-0.1,0-0.1-0.1-0.2-0.1c0,0.1,0,0.3,0,0.4c-0.1,1.2-1.1,2.2-2.3,2.2c-1.1,0-2.2,0-3.3,0c0,0-0.1,0-0.1,0 c0-0.5,0-1.1,0-1.7c0.1,0,0.1,0,0.2,0c1,0,1.9,0,2.9,0c0.6,0,0.9-0.3,0.9-1c0-0.5,0-1,0-1.5c0-0.4,0.1-0.6,0.4-0.8 c0.3-0.2,0.6-0.1,0.9,0.1c1.1,0.8,2.2,1.6,3.4,2.3c0.1,0,0.1,0.1,0.2,0.1C16.3,10.2,16.3,8,16.3,5.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/videoOff.9da79f5e21cb5016dce285001ee77c58.svg";
export { ForwardRef as ReactComponent };